<section class="stepper">
    <div class="form-title ">
        <h4 class="stepper-title text-color-black">{{step | translate}}</h4>
        <ul *ngIf="step !== 'step4'" class="stepper-pages">
            <li class='numberCircle' [ngClass]="{'active' : step === 'step1', 'done' : step !== 'step1'}">1</li>
            <li class='numberCircle' [ngClass]="{'active' : step === 'step2', 'done' : step === 'step3'}">2</li>
            <li class='numberCircle' [ngClass]="{'active' : step === 'step3' }">3</li>
        </ul>
    </div>
</section>